export default __webpack_public_path__ + "assets/img/ru.7e04b98.svg";